// components/ProtectedRoute.js
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { backendService } from "../services/backend.service";

const ProtectedRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const [isAuthorized, setIsAuthorized] = React.useState(null);
  const [userRole, setUserRole] = React.useState("");

  React.useEffect(() => {
    backendService.userProfile().then((data) => {
      setUserRole(data.aspNetRoleName);
      setIsAuthorized(
        allowedRoles.some((role) =>
          data.aspNetRoleName.toLowerCase().includes(role.toLowerCase()),
        ),
      );
    });
  }, []);

  if (isAuthorized === null) {
    return null; // o un spinner de carga
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthorized ? <Component {...props} /> : <Redirect to="/home" />
      }
    />
  );
};

export default ProtectedRoute;
